import { getPropsForClickTracking, composeAttrsForClickTracking } from "../../utils/tracking";
import { textFromTD } from "../../utils/text";
import type { MapContext } from "../map/types";
import { t } from "@ebay/i18n-ebay";
import { LIST_MENU_ICON_CLICK_ID, LIST_MENU_ENTRY_CLICK_ID } from "../map-location-tourtip/const";
$ const { model, index, selectionState } = input;
$ const { card, trackingList } = model;
$ const { title, action, image, distance, displayPrice, listingId } = card;
$ const itemListingId = listingId ?? "";
$ const getHighQualityImage = (imageURL?: string) => {
  return imageURL ? imageURL.split("s-l")[0] + "s-l500.jpg" : "";
};

<context|ctx| from="map">
  $ const { handleWatchListItemToggle, watchListItems, locality } = (ctx || {}) as MapContext;
  <li
    class="items-feed__item-wrapper"
    on-mouseenter("onItemHover", index, itemListingId)
    on-mouseleave("onUnhoverItem")
    on-focus("onItemHover", index, itemListingId)
    on-blur("onUnhoverItem")
  >
    <ebay-item-tile
      data-test-id="items-feed__item"
      class=`items-feed__item items-feed__item__${selectionState}`
      on-action("emit", "action")
      file={
        name: image?.title ?? "",
        type: image?.mediaType ?? "image/jpeg",
        src: getHighQualityImage(image?.URL),
      }
    >
      <@action>
        <item-watchlist model=card handleWatchListItemToggle=handleWatchListItemToggle watchListItems=watchListItems/>
      </@action>

      <@title class="item-tile__price">
        <item-price-display displayPrice=displayPrice isBoxed/>
      </@title>
      <@description class="item-tile__title">
        <a
          class="item-tile__title-text"
          target="_blank"
          rel="noreferrer"
          title=textFromTD(title)
          href=action?.URL
          ...getPropsForClickTracking(trackingList)
        >
          ${textFromTD(title)}
        </a>
      </@description>
      <if(distance)>
        <@description class="item-tile__distance">
          <fe-textual-display model=textFromTD(distance).split(/von|from/)[0]/>
        </@description>
      </if>

      <@description as="div" class="item-tile__menu">
        <ebay-menu-button
          variant="button"
          priority="tertiary"
          noToggleIcon
          size="small"
          reverse
          borderless
          collapseOnSelect
          on-select("onMenuSelect", locality)
          ...getPropsForClickTracking([{ ...composeAttrsForClickTracking(LIST_MENU_ICON_CLICK_ID, "button") }])
        >
          <@icon>
            <ebay-overflow-vertical-16-icon/>
          </@icon>
          <@item ...getPropsForClickTracking([{ ...composeAttrsForClickTracking(LIST_MENU_ENTRY_CLICK_ID, "button") }])>
            ${t("mapview/map", "helpAndReportMenuLabel")}
          </@item>
        </ebay-menu-button>
      </@description>
    </ebay-item-tile>
  </li>
</context>
